module.exports = __webpack_public_path__ + "../resources/images/illustration_balloon-4c4e6a9917f1b7b0edb0a85ea60469e0.svg";